<div *ngIf="isInternational" class="international-card">
    <div class="intl-card-details">
        <xm-media-image aria-hidden="true" class="icon" [imageOptions]="mediaImageOptions" size="auto">
        </xm-media-image>
        <div>
            <div class="gtp-subtitle">{{ tab.subtitle?.toUpperCase() }}</div>
            <ng-container *ngIf="isInactive">
                <div *ngIf="tab.passName" class="gtp-pass-name">{{ tab.passName }}</div>
                <div *ngIf="displayPrice" class="gtp-pass-name gtp-price">{{ displayPrice }}
                </div>
            </ng-container>
            <p class="card-description">{{ tab.body }}</p>
            <button *ngIf="tab.ctaContent && tab.lines && tab.lines.length > 0 && isGtp && isCBMInternationalReteLinkEnabled" class="xm-btn-link-light"
                (click)="onSearchTravelRatesClick()">
                {{ tab.ctaContent }}
            </button>
        </div>
    </div>
    <div class="international-lines">
        <div class="gtp-line" *ngFor="let line of tab.lines"
            [ngClass]="{'has-content': line.nickname && line.phoneNumber}">
            <ng-container *ngIf="line.nickname && line.phoneNumber">
                <div class="gtp-line-main-row">
                    <div class="gtp-line-column">
                        <span class="gtp-line-title">{{ line.nickname | titlecase }}</span>
                        <span class="gtp-line-phone-number">{{ line.phoneNumber | phone }}</span>
                    </div>
                    <div class="status-badge">
                        <xm-media-image [imageOptions]="inUseIcon"></xm-media-image>
                        <span *ngIf="line.badge" class="gtp-line-phone-number">
                            {{ line.badge }}
                        </span>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>

<div class="gtp-card" *ngIf="!isInternational">
    <ng-container *ngIf="mediaImageOptions; else fallbackImage">
        <xm-media-image aria-hidden="true" class="icon" [imageOptions]="mediaImageOptions" size="auto"></xm-media-image>
    </ng-container>

    <ng-template #fallbackImage>
        <div class="icon-wrapper">
            <img *ngIf="imageUrl" [src]="imageUrl" [alt]="tab.passName || 'Travel Pass'" class="gtp-image" />
        </div>
    </ng-template>

    <div class="card-details">
        <div class="gtp-subtitle">{{ tab.subtitle?.toUpperCase() }}</div>
        <ng-container *ngIf="isInactive">
            <div *ngIf="tab.passName" class="gtp-pass-name">{{ tab.passName }}</div>
            <div *ngIf="displayPrice" class="gtp-pass-name gtp-price">{{ displayPrice }}
            </div>
        </ng-container>
        <p class="card-description">{{ tab.body }}</p>
        <button *ngIf="tab.ctaContent && tab.lines && tab.lines.length > 0 && isGtp && isCBMInternationalReteLinkEnabled" class="xm-btn-link-light"
            (click)="onSearchTravelRatesClick()">
            {{ tab.ctaContent }}
        </button>
    </div>

    <div class="icon-status" *ngIf="isInactive || showActiveIcon" role="status">
        <xm-media-image *ngIf="showActiveIcon && inUseIcon" [imageOptions]="inUseIcon"
            class="use-icon"></xm-media-image>
        <span class="status" [ngClass]="{ 'status-icon': showActiveIcon }">{{ inactiveStatus.toLowerCase()}}</span>
    </div>

    <div class="card-btn">
        <button *ngIf="ctaLabel && isInactive" class="xm-btn-secondary-light" (click)="onAddGlobalTravelPassClick()">
            {{ ctaLabel }}
        </button>
        <button *ngIf="tab.ctaContent && isGtp && isInactive && isCBMInternationalReteLinkEnabled" class="xm-btn-link-light" (click)="onSearchTravelRatesClick()">
            {{ tab.ctaContent }}
        </button>
    </div>

</div>

<!-- if gtpLines exist, then run an ngFor lop and render it line by line -->
<div class="gtp-lines" *ngIf="!isInternational && tab.lines && tab.lines.length > 0">
    <div class="gtp-line" *ngFor="let line of tab.lines" [ngClass]="{'has-content': line.nickname && line.phoneNumber}">
        <ng-container *ngIf="line.nickname && line.phoneNumber">

            <div class="gtp-line-main-row">
                <div class="gtp-line-column">
                    <span data-notranslate class="gtp-line-title">{{ line.nickname }}</span>
                    <span class="gtp-line-phone-number">{{ line.phoneNumber }}</span>
                </div>
                <div class="gtp-line-badge-row"
                    [ngClass]="{'gtp-line-badge-pending-removal': line.badge === badgeStatusPendingRemoval}"
                    *ngIf="line.badge || inUseIcon">
                    <span *ngIf="line.badge" class="gtp-line-phone-number"
                        [ngClass]="{'gtp-line-phone-number-pending-removal': line.badge === badgeStatusPendingRemoval}">
                        {{ line.badge }}
                    </span>
                    <xm-media-image *ngIf="inUseIcon && line.badge !== badgeStatusOff" [imageOptions]="inUseIcon"
                        class="use-icon">
                    </xm-media-image>
                </div>
            </div>

            <div class="gtp-line-options">
                <!-- TODO: Allow 'Add additional data' and 'See details and add' options to be shown once MCXW team starts working on GTP's 2nd phase -->
                <!-- Render Add additional data first -->
                <ng-container *ngFor="let option of line.options">
                    <button *ngIf="isGtpIteration2 && line.status !== 'PENDING_REMOVAL' && option.content === 'Add additional data'"
                        class="xm-btn-link-light search-destination-link"
                        (click)="onAddAdditionalDataClick(line)">
                        {{ option.content }}
                    </button>
                </ng-container>
                <!-- Render Remove -->
                <ng-container *ngFor="let option of line.options">
                    <button *ngIf="line.status !== 'PENDING_REMOVAL' && option.content === 'Remove'"
                        class="xm-btn-link-light search-destination-link flush-right"
                        (click)="onOptionBtnClick({ option: option.content, phoneNumber: line.phoneNumber })">
                        {{ option.content }}
                    </button>
                </ng-container>
                <!-- Render See Details last -->
                <ng-container *ngFor="let option of line.options">
                    <button *ngIf="option.content && line.status !== 'PENDING_REMOVAL' && option.content !== 'Add additional data' && option.content !== 'Remove'"
                        class="xm-btn-link-light search-destination-link"
                        (click)="onOptionBtnClick({ option: option.content, phoneNumber: line.phoneNumber, lineId: line.lineIdKey })">
                        {{ option.content }}
                    </button>
                </ng-container>
                <!-- Render Pending Remove -->
                <ng-container *ngFor="let option of line.options">
                    <button *ngIf="option.content && line.status === 'PENDING_REMOVAL'"
                        class="xm-btn-link-light search-destination-link flush-right"
                        (click)="onCancelRemovalClick(line)">
                        {{ option.content }}
                    </button>
                </ng-container>
            </div>

        </ng-container>
    </div>
</div>
